const PRODUCTION = 'production'
const STAGING = 'staging'
const DEVELOPMENT = 'development'

const BASE_URL = window.location.origin
const HOSTNAME = window.location.hostname

const HOSTNAME_ENV_MAP = {
  staging: 'web.paperstg.co',
  production: 'app.paper.co',
  development: 'localhost'
}

const getEnv = () => {
  switch (HOSTNAME) {
    case HOSTNAME_ENV_MAP.staging:
      return STAGING
    case HOSTNAME_ENV_MAP.production:
      return PRODUCTION
    default:
      return DEVELOPMENT
  }
}

const env = getEnv()

const PAPER_CLIENT_ID_MAP = {
  staging: 'XvPowEgSCC1JmnN7euJGCpjGsXd0BVgQ',
  production: '1oSEUT4K0WyrThFO1MaNWxxkzC3T946Q',
  development: '5mZA3nXCDOdtN3U3GsXRlGuTA8zG9sns'
}
const paperClientId = PAPER_CLIENT_ID_MAP[env] || PAPER_CLIENT_ID_MAP.development

const MAJORCLARITY_CLIENT_ID_MAP = {
  staging: 'vuonwGzF9FSIwfx8ZUjkZxxsOr032YmM',
  production: 'AxpLGcUURNOeJoT88dMEdzzcuCo4B68H',
  development: 'zb5qEu3PJyFdcRhM01rboWJlRfKidwpm'
}

const MAJORCLARITY_CLIENT_TOKEN = {
  staging: '2272409a25b32cf885982fae6d4fa6a3',
  production: 'd4f82e8d91eb6a162b038a0d31b05464',
  development: 'a72ed47879dc187ae81a4c6973bb1c22'
}

const AUTH0_CLIENT_PARAMS_MAP = {
  production: {
    domain: 'login.paper.co',
    clientId: MAJORCLARITY_CLIENT_ID_MAP.production,
    audience: 'https://api.gradeslam.org',
    redirectUri: `${BASE_URL}/majorclarity/users/auth/auth0/callback`
  },
  staging: {
    domain: 'login.paperstg.co',
    clientId: MAJORCLARITY_CLIENT_ID_MAP.staging,
    audience: 'https://api.paperstg.co',
    redirectUri: `${BASE_URL}/majorclarity/users/auth/auth0/callback`
  },
  development: {
    domain: 'login.paperdev.co',
    clientId: MAJORCLARITY_CLIENT_ID_MAP.development,
    audience: 'http://localhost:8080',
    redirectUri: `${BASE_URL}/majorclarity/users/auth/auth0/callback`
  }
}

const AUTH0_CLIENT_PARAMS = AUTH0_CLIENT_PARAMS_MAP[env] || AUTH0_CLIENT_PARAMS_MAP.development
const MC_TOKEN = MAJORCLARITY_CLIENT_TOKEN[env] || MAJORCLARITY_CLIENT_TOKEN.development
const LEEWAY = 60
const SCOPE = 'openid profile email'
const PROMPT = 'none'
const auth0Config = {
  domain: AUTH0_CLIENT_PARAMS.domain,
  clientId: AUTH0_CLIENT_PARAMS.clientId,
  leeway: LEEWAY,
  authorizationParams: {
    scope: SCOPE,
    audience: AUTH0_CLIENT_PARAMS.audience,
    prompt: PROMPT,
    redirect_uri: AUTH0_CLIENT_PARAMS.redirectUri
  }
}

const MAJORCLARITY_SIGNOUT_URL = `${BASE_URL}/majorclarity/signout`
const AUTH0_USER_LOGOUT_URL = `https://${auth0Config.domain}/v2/logout?client_id=${auth0Config.clientId}&returnTo=${MAJORCLARITY_SIGNOUT_URL}&federated`
const MAJORCLARITY_LOGGING_URL = `${BASE_URL}/majorclarity/api/v1/log_request`

export { paperClientId, AUTH0_USER_LOGOUT_URL, MAJORCLARITY_LOGGING_URL, MC_TOKEN }
export default auth0Config
